<template>
  <div class="ticket-due-date">
    {{ formattedDate }}
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  props: {
    date: {
      type: [String, null],
      required: true,
    }
  },
  computed: {
    formattedDate() {
      if (!this.date) {
        return '-';
      }
      return moment(this.date).format('Do MMM YYYY');
    },
  }
}
</script>

<style scoped>
.ticket-due-date {
  display: flex;
  justify-content: center;
}
</style>
